// extracted by mini-css-extract-plugin
export default {"preloaderGif":"Preloader_preloaderGif__EyotU","preloader":"Preloader_preloader__4pYng","loadingTitle":"Preloader_loadingTitle__X7lU7","l":"Preloader_l__N1ZlN"};